// SEO Configuration for different pages
export const seoConfig = {
  home: {
    title: "Enactus MNNIT Allahabad - Empowering Communities Through Innovation",
    description: "Join Enactus MNNIT Allahabad in creating positive social impact through entrepreneurial action. Discover our projects: Neer, Samvesh, Moonj, and Sahyog.",
    keywords: "Enactus MNNIT, Social Entrepreneurship, Innovation, MNNIT Allahabad, Student Organization, Social Impact, Sustainable Development, Community Empowerment, Neer, Samvesh, Moonj, Sahyog",
    url: "https://enactus-mnnit2k25.netlify.app",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Home/img1.jpg"
  },
  
  about: {
    title: "About Us - Enactus MNNIT Allahabad",
    description: "Learn about Enactus MNNIT Allahabad, our mission, vision, and impact. Discover how we empower communities through student-led entrepreneurial action.",
    keywords: "About Enactus MNNIT, Mission, Vision, Social Impact, Student Organization, MNNIT Allahabad, Community Development",
    url: "https://enactus-mnnit2k25.netlify.app/about",
    image: "https://enactus-mnnit2k25.netlify.app/assets/logo/Enactus.png"
  },
  
  projects: {
    title: "Our Projects - Enactus MNNIT Allahabad",
    description: "Explore Enactus MNNIT's innovative social projects: Neer (water conservation), Samvesh (community integration), Moonj (sustainable crafts), and Sahyog (education support).",
    keywords: "Enactus Projects, Neer, Samvesh, Moonj, Sahyog, Social Innovation, Water Conservation, Community Development, Sustainable Crafts, Education Support",
    url: "https://enactus-mnnit2k25.netlify.app/projects",
    image: "https://enactus-mnnit2k25.netlify.app/assets/projects/images/project-showcase.jpg"
  },
  
  teams: {
    title: "Our Teams - Enactus MNNIT Allahabad",
    description: "Meet the talented teams at Enactus MNNIT: Web Development, Research & Development, Content, Design, Field Operations, and Marketing & Sponsorship.",
    keywords: "Enactus Teams, Web Team, Research Development, Content Team, Design Team, Field Officers, Marketing Team, Student Teams, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/teams",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/team-photo.jpg"
  },
  
  webTeam: {
    title: "Web Development Team - Enactus MNNIT",
    description: "Meet the Web Development Team at Enactus MNNIT. Building digital solutions and innovative web platforms to amplify our social impact initiatives.",
    keywords: "Web Development Team, Frontend Development, Backend Development, Full Stack Development, React, Node.js, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/webTeam",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/web.jpg"
  },
  
  researchTeam: {
    title: "Research & Development Team - Enactus MNNIT",
    description: "Meet the Research & Development Team at Enactus MNNIT. Conducting in-depth research and developing sustainable solutions for complex social challenges.",
    keywords: "Research Development Team, Social Research, Innovation, Sustainable Solutions, Social Challenges, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/reserchAndDevelopment",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/research.webp"
  },
  
  contentTeam: {
    title: "Content Team - Enactus MNNIT",
    description: "Meet the Content Team at Enactus MNNIT. Creating compelling content and strategic communications to tell our story and inspire change.",
    keywords: "Content Team, Content Writing, Social Media, Communications, Storytelling, Brand Management, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/contentDepartment",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/content.jpg"
  },
  
  designTeam: {
    title: "Design Team - Enactus MNNIT",
    description: "Meet the Design Team at Enactus MNNIT. Crafting visual identity and user-centered designs that communicate our mission effectively.",
    keywords: "Design Team, UI UX Design, Graphic Design, Visual Identity, Brand Design, Creative Design, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/designDepartment",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/DESIGN.jpg"
  },
  
  fieldTeam: {
    title: "Field Operations Team - Enactus MNNIT",
    description: "Meet the Field Operations Team at Enactus MNNIT. Implementing projects on ground level and directly engaging with communities to create lasting impact.",
    keywords: "Field Operations, Community Engagement, Ground Implementation, Social Impact, Field Work, Community Development, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/fieldOfficer",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/field.jpg"
  },
  
  marketingTeam: {
    title: "Marketing & Sponsorship Team - Enactus MNNIT",
    description: "Meet the Marketing & Sponsorship Team at Enactus MNNIT. Building strategic partnerships and promoting our initiatives to expand reach and secure resources.",
    keywords: "Marketing Team, Sponsorship, Brand Promotion, Strategic Partnerships, Marketing Strategy, Business Development, MNNIT",
    url: "https://enactus-mnnit2k25.netlify.app/marketingAndSponcership",
    image: "https://enactus-mnnit2k25.netlify.app/assets/Teams/SPONSORSHIP.jpg"
  },
  
  ecart: {
    title: "Shop Social Products - Enactus MNNIT",
    description: "Shop for social impact products created by Enactus MNNIT. Support community development through our sustainable and ethical product offerings.",
    keywords: "Social Products, Ethical Shopping, Community Products, Sustainable Goods, Social Impact Shopping, Enactus Store",
    url: "https://enactus-mnnit2k25.netlify.app/ecart",
    image: "https://enactus-mnnit2k25.netlify.app/assets/products/featured-product.jpg"
  }
};

// Common structured data schemas
export const structuredData = {
  organization: {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Enactus MNNIT Allahabad",
    "alternateName": "Enactus MNNIT",
    "url": "https://enactus-mnnit2k25.netlify.app",
    "logo": "https://enactus-mnnit2k25.netlify.app/assets/logo/Enactus.png",
    "description": "Student-led social entrepreneurship organization at MNNIT Allahabad empowering communities through entrepreneurial action.",
    "foundingDate": "2015",
    "numberOfEmployees": "50-100",
    "knowsAbout": ["Social Entrepreneurship", "Community Development", "Innovation", "Sustainable Development"],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "contact@enactusmnnit.org",
      "contactType": "General Inquiry",
      "availableLanguage": ["English", "Hindi"]
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Prayagraj",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "211004",
      "addressCountry": "India"
    },
    "sameAs": [
      "https://www.instagram.com/enactusmnnit",
      "https://www.linkedin.com/company/enactus-mnnit",
      "https://www.facebook.com/enactusmnnit",
      "https://twitter.com/enactusmnnit"
    ]
  },

  website: {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Enactus MNNIT Allahabad",
    "url": "https://enactus-mnnit2k25.netlify.app",
    "description": "Official website of Enactus MNNIT Allahabad - Student-led social entrepreneurship and innovation",
    "publisher": {
      "@type": "Organization",
      "name": "Enactus MNNIT Allahabad"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://enactus-mnnit2k25.netlify.app/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  },

  breadcrumbList: (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  })
};

export default seoConfig;
